const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in PHP and Laravel, experienced in building scalable, secure, and reliable web applications",
		keywords: ["Mushahid", "Mushahid H", "Mushahid Hussain"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Mushahid", "Mushahid H", "Mushahid Hussain"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Mushahid", "Mushahid H", "Mushahid Hussain"],
	},

	{
		page: "projects",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to.",
		keywords: ["Mushahid", "Mushahid H", "Mushahid Hussain"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Mushahid", "Mushahid H", "Mushahid Hussain"],
	},
];

export default SEO;
